import { render } from "./CohortControls.vue?vue&type=template&id=f2dae6ec"
import script from "./CohortControls.vue?vue&type=script&lang=ts"
export * from "./CohortControls.vue?vue&type=script&lang=ts"
script.render = render

export default script